import {
  FeedbackLabel,
  FeedbackLabelType,
  Feedback,
  FeedbackContentType,
} from 'v2/core/entities/feedback';
import { KeywordSummaryFeedback } from 'v2/core/entities/labels';
import { UUID } from 'v2/core/entities/uuid';

const getKeywordSummaryFeedback = (
  label?: FeedbackLabel,
): KeywordSummaryFeedback | undefined => {
  if (
    label?.type === FeedbackLabelType.Reason &&
    label.reasonUnits?.[0].type === 'KEYWORD_SUMMARY'
  ) {
    return label.reasonUnits?.[0];
  }
};

export const getAudioKeywordSummaryHash = (
  feedback: Feedback,
  labelID?: UUID,
) => {
  if (feedback.content.type !== FeedbackContentType.Audio) {
    return;
  }

  let label = feedback.labels?.find((label) => label.id === labelID);

  if (label?.type === FeedbackLabelType.Reason) {
    const entityLabelID =
      getKeywordSummaryFeedback(label)?.keywordSummaryLabelID;

    label = feedback.labels?.find((label) => label.id === entityLabelID);
  }

  if (label?.type === FeedbackLabelType.Entity) {
    return label.keywordSummaryHash;
  }

  return;
};
